import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Logo } from '../../../Assets';
import './completion.scss';

const Completion = () => {
  const history = useHistory();

  useEffect(() => {
    console.log('🎉 Completion screen mounted!');
    console.log('🎉 User info from localStorage:', localStorage.getItem('user_info'));
    console.log('🎉 Access token from localStorage:', localStorage.getItem('access'));
    
    // Auto redirect to dashboard after 3 seconds
    const timer = setTimeout(() => {
      console.log('🎉 Auto-redirecting to dashboard...');
   
      window.location.href = '/dashboard';
    }, 3000);

    return () => clearTimeout(timer);
  }, [history]);

  return (
    <div className="completion-wrapper">
      <div className="completion-content">
        <div className="completion-animation">
          <div className="checkmark-container">
            <div className="checkmark-circle">
              <svg 
                className="checkmark" 
                viewBox="0 0 52 52"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle 
                  className="checkmark-circle-bg" 
                  cx="26" 
                  cy="26" 
                  r="25" 
                  fill="none"
                />
                <path 
                  className="checkmark-check" 
                  fill="none" 
                  d="m14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="completion-logo">
          <Logo />
        </div>

        <div className="completion-message">
          <h1 className="completion-title">Profile Completed!</h1>
          <p className="completion-subtitle">
            Welcome to Peak Mind! Your account has been successfully set up.
          </p>
          <p className="completion-description">
            You'll be redirected to your dashboard in a few seconds...
          </p>
        </div>

        <div className="completion-progress">
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Completion;
